module.exports = __webpack_public_path__ + "static/media/ministry.15686a85.jpg";